import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/Auth";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import { AuthCallback } from "@/components/admin/AuthCallback";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import CatalogPage from "@/pages/CatalogPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import { SERVICES } from "@/lib/content";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/catalogo" element={<CatalogPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        <Route path="/protocolo" element={<Navigate to="/servicios-corporativos" replace />} />
        {Object.entries(SERVICES).map(([key, svc]) => (
          <Route key={key} path={svc.path} element={<ServicePage serviceKey={key} />} />
        ))}
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
